import React from 'react';
import PropTypes from 'prop-types';
import { TextMedium } from '../../../common/text';
import { RELEASE_COLOR_MAP, RELEASES } from '../../Timeline/Timeline.helpers';
import { RoundSquare, LegendItem, Legend } from '../../Timeline/Legend.styles';

import { RowItem, ChartHeader, RowHeaderBase } from '../ChartRowAndHeader.styles';

export const MaintenanceChartRowHeader = ({ width, chartWidth }) => (
    <ChartHeader chartWidth={chartWidth}>
        <RowHeaderBase width={width}>
            <RowItem width={100}>
                <TextMedium bold>WORK ORDER</TextMedium>
            </RowItem>
            <RowItem flex={1}>
                <TextMedium bold>AWP</TextMedium>
            </RowItem>
            <RowItem width={75}>
                <TextMedium bold>TURBINE</TextMedium>
            </RowItem>
        </RowHeaderBase>
        <Legend>
            <LegendItem>
                <RoundSquare color={RELEASE_COLOR_MAP[RELEASES.HV]}>H</RoundSquare>
                <TextMedium>HV Release</TextMedium>
            </LegendItem>
            <LegendItem>
                <RoundSquare color={RELEASE_COLOR_MAP[RELEASES.WT]}>T</RoundSquare>
                <TextMedium>WT Release</TextMedium>
            </LegendItem>
        </Legend>
    </ChartHeader>
);

MaintenanceChartRowHeader.displayName = 'MaintenanceChartRowHeader';

MaintenanceChartRowHeader.propTypes = {
    width: PropTypes.number,
};

MaintenanceChartRowHeader.defaultProps = {};
